<template>
    <table-base class="text-sm" v-bind="$attrs">
        <template #head>
            <slot name="table-head">
                <table-head>{{ $t('general.store') }}</table-head>
                <table-head>{{ $t('general.budget') }}</table-head>
                <table-head>{{ $t('general.projection') }}</table-head>
                <table-head>{{ $t('general.extrapolations') }}</table-head>
                <table-head>{{ $t('general.manual_profit_and_loss') }}</table-head>
                <table-head>{{ $t('general.actual') }}</table-head>
                <table-head></table-head>
            </slot>
        </template>
        <template #body>
            <profit-and-loss-index-row v-for="store in stores" :key="store.id" :store="store"/>
        </template>
    </table-base>
</template>

<script>
import ProfitAndLossIndexRow from '@/Pages/Dashboard/Components/ProfitAndLossIndexRow';
export default {
    components: {ProfitAndLossIndexRow},
    props: {
        stores: {
            type: Array,
        },
    },
};
</script>

<style scoped>

</style>
